import React, { useState, useEffect } from 'react';
import { Tree } from 'primereact/tree';

const PermissionTree = ({ roles, onHasChanged, onFilteredPermissions }) => {
  const [selectedNodes, setSelectedNodes] = useState({});
  const [permissionsData, setPermissionsData] = useState(null);
  const [hasChanged, setHasChanged] = useState(false);

  const filterPermissions = (inputObject) => {
    // Filtra as chaves numéricas e verifica se 'checked' ou 'partialChecked' são true
    const permissions = Object.keys(inputObject)
      .filter(key => !isNaN(key) && (inputObject[key].checked || inputObject[key].partialChecked))
      .map(key => Number(key)); // Converte as chaves para números

    // Retorna o array no formato esperado
    return { permissions };
  };

  const onNodeSelect = (node) => {
    // console.log("Node: ", node)
    setSelectedNodes(node);
    const result = filterPermissions(node);
    onFilteredPermissions(result);
    onHasChanged(true);
  };

  const convertPermissionsToTree = (data, nodesMap = {}) => {
    return Object.entries(data).map(([key, value]) => {
      const nodeKey = value.category || `${key}`;

      if (nodesMap[nodeKey]) {
        const newChildren = value.permissions.map(permission => createChildNode(permission, nodesMap));
        nodesMap[nodeKey].children = [...(nodesMap[nodeKey].children || []), ...newChildren];
        return nodesMap[nodeKey];
      }
      const children = value.permissions
        .map(permission => createChildNode(permission, nodesMap))
        .sort((a, b) => {
          const aHasChildren = a.children && a.children.length > 0;
          const bHasChildren = b.children && b.children.length > 0;
          if (aHasChildren && !bHasChildren) return -1;
          if (!aHasChildren && bHasChildren) return 1;
          return 0;
        });

      const categoryNode = {
        key: nodeKey,
        label: value.category || `Categoria-${key}`,
        icon: 'fa fa-folder',
        children: children.length > 0 ? children : null,
        checked: value.permissions.some(p => p.enabled),
        partialChecked: false
      };


      nodesMap[nodeKey] = categoryNode;
      return categoryNode;
    });
  };


  const createChildNode = (permission, nodesMap) => {
    const childKey = permission.id;
    if (nodesMap[childKey]) {
      return nodesMap[childKey];
    }

    const childPermissions = permission.children
      ? permission.children.map(child => createChildNode(child, nodesMap))
      : null;

    const childNode = {
      key: childKey,
      label: permission.name,
      data: permission,
      children: childPermissions && childPermissions.length > 0 ? childPermissions : null,
      checked: permission.enabled,
      partialChecked: false
    };

    nodesMap[childKey] = childNode;
    return childNode;
  };

  useEffect(() => {
    if (roles) {
      const rolesConvert = convertPermissionsToTree(roles.data);
      console.log(rolesConvert)
      setPermissionsData(rolesConvert)

    }
  }, [roles]);

  useEffect(() => {
    if (permissionsData) {
      // Inicializa selectedNodes com base nas permissões que já estão habilitadas
      const initSelectedNodes = {};
      const markCheckedNodes = (nodes) => {
        nodes.forEach(node => {
          if (node.checked) {
            initSelectedNodes[node.key] = {
              checked: true,
              partialChecked: false
            };
          }
          if (node.children) {
            markCheckedNodes(node.children);
          }
        });
      };
      markCheckedNodes(permissionsData);
      setSelectedNodes(initSelectedNodes);
    }
  }, [permissionsData]);

  return (
    <div className='pt-5'>
      {permissionsData && (
        <Tree
          value={permissionsData}
          selectionMode="checkbox" // Ativando seleção com checkboxes
          selectionKeys={selectedNodes}
          onSelectionChange={e => onNodeSelect(e.value)}
          // propagateSelectionDown={false} 
          propagateSelectionUp={false}
          metaKeySelection={false} // Para não usar a tecla Meta (Ctrl ou Cmd)
          icon="fa fa-folder" // Ícone padrão para nós
          filter filterMode="lenient" filterPlaceholder="Buscar permissão"
          content={node => (
            <div>
              <i className={node.icon}></i> {/* Renderiza o ícone Font Awesome */}
              {node.label}
            </div>
          )}
        />
      )}
      {/* <div>
        <h4>Selected Nodes:</h4>
        <pre>{JSON.stringify(selectedNodes, null, 2)}</pre>
      </div> */}
    </div>
  );
};

export default PermissionTree;
